import type { InboxNotice, OpsIncidentKey } from '@sbc/domain-models/gateway';
import { AlertTriangle } from 'lucide-react';

const SINCE = new Intl.DateTimeFormat('en-US', {
  timeZone: 'UTC',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

const NOTICE_TEXT: Record<OpsIncidentKey, (since: string) => string> = {
  'shop-db-reads': (since) =>
    `Member account facts are unavailable since ${since}. Drafts are written without ` +
    'orders, subscriptions or tracking. Engineering has been notified.',
  'quo-credits': (since) =>
    `Quo is out of SMS credits since ${since}. Texts can't be sent until someone tops up ` +
    'in Quo → Settings → Plan & billing.',
};

export function inboxNoticeText(notice: InboxNotice): string {
  return NOTICE_TEXT[notice.key](`${SINCE.format(new Date(notice.failingSince))} UTC`);
}

export function InboxNotices({ notices }: { notices: readonly InboxNotice[] }) {
  if (notices.length === 0) {
    return null;
  }
  return (
    <output className="block shrink-0 space-y-1 border-b p-2">
      {notices.map((notice) => (
        <div
          key={notice.key}
          className="flex items-start gap-2 rounded-md border border-[var(--color-destructive)] bg-[var(--color-destructive)]/10 p-2.5 text-sm"
        >
          <AlertTriangle className="mt-0.5 size-4 shrink-0 text-[var(--color-destructive)]" />
          <p>{inboxNoticeText(notice)}</p>
        </div>
      ))}
    </output>
  );
}
